// version.ts — رقم إصدار واجهة إعادة البناء (frontend-Vit2). كان يتابع خطّ 3.5.0→3.14.8،
// لكن بطلب المستخدم أُعيد ترقيمه ليبدأ من 4.0.1 (2026-07-21) — و`backend-node22` أُعيد
// ترقيمه معه لنفس الرقم بطلب لاحق، فصار خطّ "Track B" كلّه (Vit2 + node22) يتشارك رقم
// إصدار واحد من 4.0.1 فصاعدًا (بنفس نمط `frontend/`+`backend/` القديمَين اللذين
// يتشاركان رقمًا واحدًا أيضًا) — يميّز "4.x" هذا الخطّ بالكامل عن `frontend/` القديمة
// (تبقى ضمن 3.x، حاليًّا v3.4.96). **حدِّث كلا الملفّين معًا عند كل رفع إصدار جديد**:
// هذا الملف و`backend-node22/package.json`.
export const APP_VERSION = '4.0.7';
export const APP_RELEASE_DATE = '2026-07-21';
export const APP_VERSION_LABEL = `v${APP_VERSION}`;

export default APP_VERSION;
